import React from 'react';
import { LogOut, Shield } from 'lucide-react';
import { api } from '../lib/api';

export default function ImpersonationBanner() {
  const isActive = localStorage.getItem('impersonation_active') === 'true';
  if (!isActive) return null;

  const email = localStorage.getItem('impersonation_email') || 'unknown user';
  const name = localStorage.getItem('impersonation_name') || '';

  const handleExit = async () => {
    try {
      // Restore admin session
      const saved = JSON.parse(sessionStorage.getItem('admin_impersonation') || '{}');
      const adminToken = saved.admin_token;
      const returnPath = saved.return_path || '/admin/user-management';

      // End impersonation on backend
      if (adminToken) {
        try { await api.adminEndImpersonation(adminToken); } catch { /* best effort */ }
      }

      // Clean up impersonation state
      localStorage.removeItem('impersonation_active');
      localStorage.removeItem('impersonation_email');
      localStorage.removeItem('impersonation_name');
      sessionStorage.removeItem('everbook_token');
      sessionStorage.removeItem('admin_impersonation');

      // Redirect back to admin
      window.location.href = returnPath;
    } catch {
      // Force cleanup
      localStorage.removeItem('impersonation_active');
      window.location.href = '/admin/user-management';
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-gradient-to-r from-amber-600 via-orange-500 to-amber-600 text-white shadow-lg"
      data-testid="impersonation-banner"
    >
      <div className="max-w-screen-xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <Shield className="w-4 h-4" />
          <span className="text-sm font-semibold tracking-wide">ADMIN MODE</span>
          <span className="text-sm opacity-90">
            — Viewing account as <strong>{name || email}</strong>
          </span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-1.5 px-3 py-1 bg-[#141414]/20 hover:bg-[#141414]/30 rounded-lg text-sm font-medium transition-colors"
          data-testid="exit-impersonation-btn"
        >
          <LogOut className="w-3.5 h-3.5" />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
}
